import { render, staticRenderFns } from "./activityPayment.vue?vue&type=template&id=4895b4b6&"
import script from "./activityPayment.vue?vue&type=script&lang=js&"
export * from "./activityPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports